import EditArea from "./EditArea.tsx";
import React from "react";
import MarkdownContent from "./MarkdownContent.tsx";

interface MessageContentProps {
    group: any;
    editedContent: any;
    setEditedContent: any;
    editingId: null | number;
}

const Content: React.FC<MessageContentProps> = (
    {
        group,
        editingId,
        editedContent,
        setEditedContent
    }) => {
    const getContentMode = () => {
        if (group.groupRole === 'assistant') {
            return 'border border-neutral-500 dark:border-neutral-700 border-opacity-35 dark:border-opacity-25'
        } else {
            return 'ml-auto border border-neutral-400 dark:border-neutral-700 border-opacity-35 dark:border-opacity-25 bg-zinc-300 dark:bg-zinc-800'
        }
    }
    const contentMode = getContentMode();

    return (
        <div
            key={group.index}
            className={`px-3.5 py-2.5 rounded-2xl max-w-full ${contentMode}`}
        >
            {editingId === group.index ? (
                <EditArea
                    editedContent={editedContent}
                    setEditedContent={setEditedContent}
                />
            ) : (
                <MarkdownContent group={group}/>
            )}
        </div>
    )
}

export default Content;